import React from 'react';
import Modal from '../Modal';
import AjanloiProgramAuth from '../pages/AjanloiProgramAuth';

export default function AjanloiProgramUjRegisztracioModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} transparent>
      <AjanloiProgramAuth />
    </Modal>
  );
}
